import { Pipe, PipeTransform } from '@angular/core';

import { ColumnDataType, TagItemInfo } from '@blaze-shared/api-contracts-domain';
import { ColumnType, DatasetColumn, DatasetColumnFormat } from '@blaze-shared/schema-domain';
import { getFilenameFromUrl, isNullish } from '@blaze-shared/shared-util';
import { getItemTypeIcon } from '@blaze-shared/uploader';

@Pipe({
  name: 'isColumnType',
})
export class IsColumnTypePipe implements PipeTransform {
  transform(column: DatasetColumn, columnType: ColumnType): boolean {
    return column?.columnType === columnType;
  }
}

@Pipe({
  name: 'isDataType',
})
export class IsDataTypePipe implements PipeTransform {
  transform(column: DatasetColumn, dataType: ColumnDataType): boolean {
    return column?.dataType === dataType;
  }
}

@Pipe({
  name: 'isMultiValueLink',
})
export class IsMultiValueLinkPipe implements PipeTransform {
  transform(column: DatasetColumn): boolean {
    return !!column.link?.multipleValues;
  }
}
@Pipe({
  name: 'isFormatType',
})
export class IsFormatTypePipe implements PipeTransform {
  transform(column: DatasetColumn, formatType: DatasetColumnFormat['formatType']): boolean {
    return column?.format?.formatType === formatType;
  }
}

@Pipe({
  name: 'isSecureText',
})
export class IsSecureTextPipe implements PipeTransform {
  transform(column: DatasetColumn): boolean {
    return (column.isSecure && column.dataType === 'String') || false;
  }
}

@Pipe({
  name: 'toArray',
  standalone: false,
})
export class ToArrayPipe implements PipeTransform {
  transform<T = string>(value: T | T[]): T[] {
    if (Array.isArray(value)) {
      return value;
    } else if (!isNullish(value)) {
      return [value];
    } else {
      return [];
    }
  }
}

@Pipe({
  name: 'getFileThumb',
  standalone: false,
})
export class GetFileThumbPipe implements PipeTransform {
  transform(value: string): string {
    return getItemTypeIcon(value);
  }
}

@Pipe({
  name: 'getFileName',
  standalone: false,
})
export class GetFileNamePipe implements PipeTransform {
  transform(value: string): string {
    return getFilenameFromUrl(value);
  }
}

@Pipe({
  name: 'getTagStyling',
  standalone: false,
})
export class GetTagStylingPipe implements PipeTransform {
  transform(
    definitions: TagItemInfo[] | undefined,
    value: string,
  ): { color: string; backgroundColor: string } | undefined {
    const tagDef = definitions?.find((col) => col.value === value);
    return tagDef
      ? { color: tagDef.foregroundColor, backgroundColor: tagDef.backgroundColor }
      : undefined;
  }
}

@Pipe({
  name: 'sort',
  standalone: false,
})
export class SortPipe implements PipeTransform {
  transform(value: string[], asc = true): string[] {
    return value.sort((a, b) => (asc ? a.localeCompare(b) : b.localeCompare(a)));
  }
}

export const FIELD_INPUT_PIPES = [
  ToArrayPipe,
  GetFileNamePipe,
  GetFileThumbPipe,
  GetTagStylingPipe,
  SortPipe,
];

export const STANDALONE_FIELD_INPUT_PIPES = [
  IsColumnTypePipe,
  IsDataTypePipe,
  IsFormatTypePipe,
  IsSecureTextPipe,
  IsMultiValueLinkPipe,
];
